import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'RememberCheckboxComponent',
  setup(__props) {

// import { ref } from 'vue'
const { t } = useI18n()
const text = {
  forget: t('views.login.forget') as string,
  remember: t('views.login.remember') as string
}

// DATA
const rememberUrl = process.env.VUE_APP_REMEMBER_PASS_URL
// const rememberPassword = ref(false)

return { __sfc: true,t, text, rememberUrl }
}

})